$(document).ready(function() {
    // Function to reset transforms for a set of elements
    function resetTransforms($elements) {
        // Handle single jQuery object or array of jQuery objects
        if ($elements instanceof jQuery) {
            $elements.css('transform', 'translateY(0)');
        } else {
            $elements.forEach($el => $el.css('transform', 'translateY(0)'));
        }
    }

    // Function to set up parallax for .section--textmedia (using Intersection Observer)
    function setupTextmediaParallax($section, largeImageSelector, smallImageSelectors, namespace, largeImageOffsetPx, smallImageOffsets) {
        if (!$section.length) {
            console.log(`[Parallax Debug] Section for ${namespace} not found.`);
            return;
        }

        const $largeImage = $section.find(largeImageSelector).first();
        const $smallImages = smallImageSelectors
            .map(sel => $section.find(sel).first())
            .filter($el => $el.length);
        const $galleryButton = $section.find('.textbild--gallery--outer .gallery--button').first();

        if (!$largeImage.length) {
            console.log(`[Parallax Debug] Large image not found for ${namespace}.`);
            return;
        }
        if (!$smallImages.length && !$galleryButton.length) {
            console.log(`[Parallax Debug] No small images or gallery button found for ${namespace}.`);
            return;
        }

        console.log(`[Parallax Debug] Setting up parallax for ${namespace}, found largeImage: ${$largeImage.length}, smallImages: ${$smallImages.length}, galleryButton: ${$galleryButton.length}`);

        const observer = new IntersectionObserver(
            (entries) => {
                entries.forEach(entry => {
                    if (entry.isIntersecting) {
                        console.log(`[Parallax Debug] ${namespace} is intersecting, binding scroll event.`);
                        $(window).on(`scroll.${namespace}`, function() {
                            const scrollTop = $(window).scrollTop();
                            const sectionTop = $section.offset().top;
                            const sectionHeight = $section.height();
                            const windowHeight = $(window).height();

                            const progress = Math.min(Math.max((scrollTop - sectionTop + windowHeight) / (sectionHeight + windowHeight), 0), 1);

                            const largeImageOffset = progress * largeImageOffsetPx;
                            $largeImage.css('transform', `translateY(${largeImageOffset}px)`);
                            if ($galleryButton.length) {
                                $galleryButton.css('transform', `translateY(${largeImageOffset}px)`);
                            }
                            $smallImages.forEach(($el, index) => {
                                const offset = smallImageOffsets[index] ? -progress * smallImageOffsets[index] : -progress * 30;
                                $el.css('transform', `translateY(${offset}px)`);
                            });
                        });
                    } else {
                        console.log(`[Parallax Debug] ${namespace} is not intersecting, unbinding scroll event.`);
                        $(window).off(`scroll.${namespace}`);
                        resetTransforms($largeImage);
                        resetTransforms($smallImages);
                        if ($galleryButton.length) {
                            resetTransforms($galleryButton);
                        }
                    }
                });
            },
            {
                root: null,
                threshold: 0,
                rootMargin: '100px'
            }
        );

        observer.observe($section[0]);
    }

    // Function to set up parallax for cover sections (scroll-based)
    function setupCoverParallax($section, largeImageSelector, smallImageSelectors, namespace, largeImageOffsetPx, smallImageOffsets) {
        if (!$section.length) {
            console.log(`[Parallax Debug] Section for ${namespace} not found.`);
            return;
        }

        const $largeImage = $section.find(largeImageSelector).first();
        const $smallImages = smallImageSelectors
            .map(sel => $section.find(sel).first())
            .filter($el => $el.length);

        if (!$largeImage.length) {
            console.log(`[Parallax Debug] Large image not found for ${namespace}.`);
            return;
        }
        if (!$smallImages.length) {
            console.log(`[Parallax Debug] No small images found for ${namespace}.`);
            return;
        }

        console.log(`[Parallax Debug] Setting up parallax for ${namespace}, found largeImage: ${$largeImage.length}, smallImages: ${$smallImages.length}`);

        $(window).on(`scroll.${namespace}`, function() {
            const scrollTop = $(window).scrollTop();
            if (scrollTop <= 10) {
                console.log(`[Parallax Debug] ${namespace} at page top, resetting transforms.`);
                resetTransforms($largeImage);
                resetTransforms($smallImages);
                return;
            }

            const sectionTop = $section.offset().top;
            const sectionHeight = $section.height();
            const windowHeight = $(window).height();

            const progress = Math.min(Math.max((scrollTop - sectionTop + windowHeight) / (sectionHeight + windowHeight), 0), 1);

            const largeImageOffset = progress * largeImageOffsetPx;
            $largeImage.css('transform', `translateY(${largeImageOffset}px)`);
            $smallImages.forEach(($el, index) => {
                const offset = smallImageOffsets[index] ? -progress * smallImageOffsets[index] : -progress * 30;
                $el.css('transform', `translateY(${offset}px)`);
            });
        });

        // Initial reset on page load
        resetTransforms($largeImage);
        resetTransforms($smallImages);
    }

    // Handle .section--textmedia
    if ($('.section--textmedia').length) {
        console.log('[Parallax Debug] Found section--textmedia elements:', $('.section--textmedia').length);
        $('.section--textmedia').each(function(index) {
            setupTextmediaParallax(
                $(this),
                '.block--img .image--sirv',
                ['.after--rect'],
                `parallax_textmedia_${index}`,
                50, // Pixel amount for large image in textmedia
                [30]
            );
        });
    }

    // Handle .cover-home
    if ($('.cover-home').length) {
        console.log('[Parallax Debug] Found cover-home elements:', $('.cover-home').length);
        $('.cover-home').each(function(index) {
            setupCoverParallax(
                $(this),
                '.image--1 .image--sirv',
                ['.image--2 .image--sirv', '.image--3 .image--sirv'],
                `parallax_coverhome_${index}`,
                10, // Pixel amount for .image--1
                [10, 30] // 10px for .image--2, 20px for .image--3
            );
        });
    }

    // Handle .cover-sub (non-centered)
    if ($('.cover-sub').length) {
        console.log('[Parallax Debug] Found cover-sub elements:', $('.cover-sub').length);
        $('.cover-sub:not(.cover_zentriert)').each(function(index) {
            setupCoverParallax(
                $(this),
                '.right .image--1 .image--sirv',
                ['.right .image--2 .image--sirv'],
                `parallax_coversub_${index}`,
                10, // Pixel amount for .image--1
                [20]
            );
        });
    }


});



$(document).ready(function() {
    // Funktion für Team-Item Animation
    function setupTeamAnimation($container, itemSelector, offsetNormal, offsetSmall) {
        var $items = $container.find(itemSelector);
        if ($items.length === 0) return; // Skip if no items found
        
        var hoveredIndex = -1;

        // Mousemove-Event auf diesem Container
        $container.on('mousemove', function(event) {
            var $target = $(event.target).closest(itemSelector);
            if ($target.length) {
                var newIndex = $items.index($target);
                if (newIndex !== hoveredIndex) {
                    hoveredIndex = newIndex;
                    updatePositions();
                }
            }
            // Kein Reset in Gaps – behält letzte Position bei
        });

        // Mouseleave auf diesem Container
        $container.on('mouseleave', function() {
            hoveredIndex = -1;
            updatePositions();
        });

        function updatePositions() {
            $items.each(function(siblingIndex) {
                var $sibling = $(this);
                if (hoveredIndex === -1) {
                    $sibling.css('transform', ''); // Reset
                } else if (siblingIndex > hoveredIndex) {
                    var $hoveredItem = $items.eq(hoveredIndex);
                    var offset = $hoveredItem.hasClass('small') ? offsetSmall : offsetNormal;
                    $sibling.css('transform', 'translateX(' + offset + 'px)');
                } else {
                    $sibling.css('transform', ''); // Linke Items unberührt
                }
            });
        }
    }

    // Finde alle .cover--team--container Container (größerer Offset)
    var $coverContainers = $('.cover--team--container');
    $coverContainers.each(function() {
        setupTeamAnimation($(this), '.cover--team--item', 25, 16);
    });

    // Finde alle .flex--team--container Container (kleinerer Offset)
    var $flexContainers = $('.flex--team--container').has('.flex--team--item');
    $flexContainers.each(function() {
        setupTeamAnimation($(this), '.flex--team--item', 15, 10);
    });
});